export default __webpack_public_path__ + "static/gitex-video-poster-74f34489213a3b5f80d54fef177a51a1.png";